// source: knowledge-api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
goog.exportSymbol('proto.knowledge_api.CreateKnowledgeDocumentRequest', null, global);
goog.exportSymbol('proto.knowledge_api.CreateKnowledgeDocumentRequest.DOCUMENT_SOURCE', null, global);
goog.exportSymbol('proto.knowledge_api.CreateKnowledgeDocumentRequest.PRE_PROCESS', null, global);
goog.exportSymbol('proto.knowledge_api.CreateKnowledgeDocumentResponse', null, global);
goog.exportSymbol('proto.knowledge_api.CreateKnowledgeRequest', null, global);
goog.exportSymbol('proto.knowledge_api.CreateKnowledgeResponse', null, global);
goog.exportSymbol('proto.knowledge_api.CreateKnowledgeTagRequest', null, global);
goog.exportSymbol('proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest', null, global);
goog.exportSymbol('proto.knowledge_api.GetAllKnowledgeDocumentRequest', null, global);
goog.exportSymbol('proto.knowledge_api.GetAllKnowledgeDocumentResponse', null, global);
goog.exportSymbol('proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest', null, global);
goog.exportSymbol('proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse', null, global);
goog.exportSymbol('proto.knowledge_api.GetAllKnowledgeRequest', null, global);
goog.exportSymbol('proto.knowledge_api.GetAllKnowledgeResponse', null, global);
goog.exportSymbol('proto.knowledge_api.GetKnowledgeRequest', null, global);
goog.exportSymbol('proto.knowledge_api.GetKnowledgeResponse', null, global);
goog.exportSymbol('proto.knowledge_api.KnowledgeDocument', null, global);
goog.exportSymbol('proto.knowledge_api.KnowledgeDocumentSegment', null, global);
goog.exportSymbol('proto.knowledge_api.KnowledgeDocumentSegment.Entities', null, global);
goog.exportSymbol('proto.knowledge_api.KnowledgeDocumentSegment.Metadata', null, global);
goog.exportSymbol('proto.knowledge_api.UpdateKnowledgeDetailRequest', null, global);
goog.exportSymbol('proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.CreateKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.CreateKnowledgeRequest.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.CreateKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.CreateKnowledgeRequest.displayName = 'proto.knowledge_api.CreateKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.CreateKnowledgeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.CreateKnowledgeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.CreateKnowledgeResponse.displayName = 'proto.knowledge_api.CreateKnowledgeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetAllKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.GetAllKnowledgeRequest.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.GetAllKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetAllKnowledgeRequest.displayName = 'proto.knowledge_api.GetAllKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetAllKnowledgeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.GetAllKnowledgeResponse.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.GetAllKnowledgeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetAllKnowledgeResponse.displayName = 'proto.knowledge_api.GetAllKnowledgeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.GetKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetKnowledgeRequest.displayName = 'proto.knowledge_api.GetKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetKnowledgeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.GetKnowledgeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetKnowledgeResponse.displayName = 'proto.knowledge_api.GetKnowledgeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.CreateKnowledgeTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.CreateKnowledgeTagRequest.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.CreateKnowledgeTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.CreateKnowledgeTagRequest.displayName = 'proto.knowledge_api.CreateKnowledgeTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.KnowledgeDocument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.KnowledgeDocument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.KnowledgeDocument.displayName = 'proto.knowledge_api.KnowledgeDocument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.GetAllKnowledgeDocumentRequest.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.GetAllKnowledgeDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetAllKnowledgeDocumentRequest.displayName = 'proto.knowledge_api.GetAllKnowledgeDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.GetAllKnowledgeDocumentResponse.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.GetAllKnowledgeDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetAllKnowledgeDocumentResponse.displayName = 'proto.knowledge_api.GetAllKnowledgeDocumentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.CreateKnowledgeDocumentRequest.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.CreateKnowledgeDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.CreateKnowledgeDocumentRequest.displayName = 'proto.knowledge_api.CreateKnowledgeDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.CreateKnowledgeDocumentResponse.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.CreateKnowledgeDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.CreateKnowledgeDocumentResponse.displayName = 'proto.knowledge_api.CreateKnowledgeDocumentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.KnowledgeDocumentSegment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.KnowledgeDocumentSegment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.KnowledgeDocumentSegment.displayName = 'proto.knowledge_api.KnowledgeDocumentSegment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.KnowledgeDocumentSegment.Metadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.KnowledgeDocumentSegment.Metadata.displayName = 'proto.knowledge_api.KnowledgeDocumentSegment.Metadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.KnowledgeDocumentSegment.Entities.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.KnowledgeDocumentSegment.Entities, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.KnowledgeDocumentSegment.Entities.displayName = 'proto.knowledge_api.KnowledgeDocumentSegment.Entities';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.displayName = 'proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.displayName = 'proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.UpdateKnowledgeDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.UpdateKnowledgeDetailRequest.displayName = 'proto.knowledge_api.UpdateKnowledgeDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.repeatedFields_, null);
};
goog.inherits(proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.displayName = 'proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.displayName = 'proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.CreateKnowledgeRequest.repeatedFields_ = [4,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.CreateKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.CreateKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    visibility: jspb.Message.getFieldWithDefault(msg, 5, ""),
    embeddingmodelproviderid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    embeddingmodelprovidername: jspb.Message.getFieldWithDefault(msg, 7, ""),
    knowledgeembeddingmodeloptionsList: jspb.Message.toObjectList(msg.getKnowledgeembeddingmodeloptionsList(),
    common_pb.Metadata.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.CreateKnowledgeRequest}
 */
proto.knowledge_api.CreateKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.CreateKnowledgeRequest;
  return proto.knowledge_api.CreateKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.CreateKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.CreateKnowledgeRequest}
 */
proto.knowledge_api.CreateKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisibility(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEmbeddingmodelproviderid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmbeddingmodelprovidername(value);
      break;
    case 8:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addKnowledgeembeddingmodeloptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.CreateKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.CreateKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getVisibility();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmbeddingmodelproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getEmbeddingmodelprovidername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getKnowledgeembeddingmodeloptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string tags = 4;
 * @return {!Array<string>}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional string visibility = 5;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.getVisibility = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 embeddingModelProviderId = 6;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.getEmbeddingmodelproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.setEmbeddingmodelproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string embeddingModelProviderName = 7;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.getEmbeddingmodelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.setEmbeddingmodelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Metadata knowledgeEmbeddingModelOptions = 8;
 * @return {!Array<!proto.Metadata>}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.getKnowledgeembeddingmodeloptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 8));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
*/
proto.knowledge_api.CreateKnowledgeRequest.prototype.setKnowledgeembeddingmodeloptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.addKnowledgeembeddingmodeloptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.CreateKnowledgeRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeRequest.prototype.clearKnowledgeembeddingmodeloptionsList = function() {
  return this.setKnowledgeembeddingmodeloptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.CreateKnowledgeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.CreateKnowledgeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && common_pb.Knowledge.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.CreateKnowledgeResponse}
 */
proto.knowledge_api.CreateKnowledgeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.CreateKnowledgeResponse;
  return proto.knowledge_api.CreateKnowledgeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.CreateKnowledgeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.CreateKnowledgeResponse}
 */
proto.knowledge_api.CreateKnowledgeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Knowledge;
      reader.readMessage(value,common_pb.Knowledge.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.CreateKnowledgeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.CreateKnowledgeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Knowledge.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.CreateKnowledgeResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.knowledge_api.CreateKnowledgeResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Knowledge data = 3;
 * @return {?proto.Knowledge}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.getData = function() {
  return /** @type{?proto.Knowledge} */ (
    jspb.Message.getWrapperField(this, common_pb.Knowledge, 3));
};


/**
 * @param {?proto.Knowledge|undefined} value
 * @return {!proto.knowledge_api.CreateKnowledgeResponse} returns this
*/
proto.knowledge_api.CreateKnowledgeResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.CreateKnowledgeResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.knowledge_api.CreateKnowledgeResponse} returns this
*/
proto.knowledge_api.CreateKnowledgeResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.CreateKnowledgeResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.CreateKnowledgeResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.GetAllKnowledgeRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetAllKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetAllKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetAllKnowledgeRequest}
 */
proto.knowledge_api.GetAllKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetAllKnowledgeRequest;
  return proto.knowledge_api.GetAllKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetAllKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetAllKnowledgeRequest}
 */
proto.knowledge_api.GetAllKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 2:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetAllKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetAllKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional Paginate paginate = 1;
 * @return {?proto.Paginate}
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 1));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeRequest} returns this
*/
proto.knowledge_api.GetAllKnowledgeRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Criteria criterias = 2;
 * @return {!Array<!proto.Criteria>}
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 2));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.knowledge_api.GetAllKnowledgeRequest} returns this
*/
proto.knowledge_api.GetAllKnowledgeRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.GetAllKnowledgeRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.GetAllKnowledgeResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetAllKnowledgeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetAllKnowledgeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.Knowledge.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse}
 */
proto.knowledge_api.GetAllKnowledgeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetAllKnowledgeResponse;
  return proto.knowledge_api.GetAllKnowledgeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetAllKnowledgeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse}
 */
proto.knowledge_api.GetAllKnowledgeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Knowledge;
      reader.readMessage(value,common_pb.Knowledge.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetAllKnowledgeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetAllKnowledgeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Knowledge.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Knowledge data = 3;
 * @return {!Array<!proto.Knowledge>}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Knowledge>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Knowledge, 3));
};


/**
 * @param {!Array<!proto.Knowledge>} value
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Knowledge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Knowledge}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Knowledge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetKnowledgeRequest}
 */
proto.knowledge_api.GetKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetKnowledgeRequest;
  return proto.knowledge_api.GetKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetKnowledgeRequest}
 */
proto.knowledge_api.GetKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.knowledge_api.GetKnowledgeRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.GetKnowledgeRequest} returns this
 */
proto.knowledge_api.GetKnowledgeRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetKnowledgeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetKnowledgeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetKnowledgeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && common_pb.Knowledge.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetKnowledgeResponse}
 */
proto.knowledge_api.GetKnowledgeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetKnowledgeResponse;
  return proto.knowledge_api.GetKnowledgeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetKnowledgeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetKnowledgeResponse}
 */
proto.knowledge_api.GetKnowledgeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Knowledge;
      reader.readMessage(value,common_pb.Knowledge.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetKnowledgeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetKnowledgeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetKnowledgeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Knowledge.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.GetKnowledgeResponse} returns this
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.knowledge_api.GetKnowledgeResponse} returns this
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Knowledge data = 3;
 * @return {?proto.Knowledge}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.getData = function() {
  return /** @type{?proto.Knowledge} */ (
    jspb.Message.getWrapperField(this, common_pb.Knowledge, 3));
};


/**
 * @param {?proto.Knowledge|undefined} value
 * @return {!proto.knowledge_api.GetKnowledgeResponse} returns this
*/
proto.knowledge_api.GetKnowledgeResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetKnowledgeResponse} returns this
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.knowledge_api.GetKnowledgeResponse} returns this
*/
proto.knowledge_api.GetKnowledgeResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetKnowledgeResponse} returns this
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetKnowledgeResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.CreateKnowledgeTagRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.CreateKnowledgeTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.CreateKnowledgeTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.CreateKnowledgeTagRequest}
 */
proto.knowledge_api.CreateKnowledgeTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.CreateKnowledgeTagRequest;
  return proto.knowledge_api.CreateKnowledgeTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.CreateKnowledgeTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.CreateKnowledgeTagRequest}
 */
proto.knowledge_api.CreateKnowledgeTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.CreateKnowledgeTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.CreateKnowledgeTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional uint64 knowledgeId = 1;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeTagRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * repeated string tags = 2;
 * @return {!Array<string>}
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.CreateKnowledgeTagRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.CreateKnowledgeTagRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.CreateKnowledgeTagRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeTagRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.KnowledgeDocument.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.KnowledgeDocument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.KnowledgeDocument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocument.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    language: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    documentsource: (f = msg.getDocumentsource()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    documenttype: jspb.Message.getFieldWithDefault(msg, 7, ""),
    documentsize: jspb.Message.getFieldWithDefault(msg, 8, 0),
    documentpath: jspb.Message.getFieldWithDefault(msg, 9, ""),
    indexstatus: jspb.Message.getFieldWithDefault(msg, 10, ""),
    retrievalcount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    tokencount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    wordcount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    displaystatus: jspb.Message.getFieldWithDefault(msg, 19, ""),
    status: jspb.Message.getFieldWithDefault(msg, 21, ""),
    createdby: jspb.Message.getFieldWithDefault(msg, 22, "0"),
    createduser: (f = msg.getCreateduser()) && common_pb.User.toObject(includeInstance, f),
    updatedby: jspb.Message.getFieldWithDefault(msg, 24, "0"),
    updateduser: (f = msg.getUpdateduser()) && common_pb.User.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.KnowledgeDocument}
 */
proto.knowledge_api.KnowledgeDocument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.KnowledgeDocument;
  return proto.knowledge_api.KnowledgeDocument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.KnowledgeDocument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.KnowledgeDocument}
 */
proto.knowledge_api.KnowledgeDocument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setDocumentsource(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumenttype(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDocumentsize(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentpath(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexstatus(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRetrievalcount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTokencount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setWordcount(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplaystatus(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCreatedby(value);
      break;
    case 23:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setCreateduser(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUpdatedby(value);
      break;
    case 25:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setUpdateduser(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.KnowledgeDocument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.KnowledgeDocument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.KnowledgeDocument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDocumentsource();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getDocumenttype();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDocumentsize();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getDocumentpath();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIndexstatus();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRetrievalcount();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getTokencount();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getWordcount();
  if (f !== 0) {
    writer.writeUint64(
      14,
      f
    );
  }
  f = message.getDisplaystatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCreatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      22,
      f
    );
  }
  f = message.getCreateduser();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      24,
      f
    );
  }
  f = message.getUpdateduser();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 knowledgeId = 2;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string language = 3;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Struct documentSource = 6;
 * @return {?proto.google.protobuf.Struct}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getDocumentsource = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 6));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
*/
proto.knowledge_api.KnowledgeDocument.prototype.setDocumentsource = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.clearDocumentsource = function() {
  return this.setDocumentsource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.KnowledgeDocument.prototype.hasDocumentsource = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string documentType = 7;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getDocumenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setDocumenttype = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 documentSize = 8;
 * @return {number}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getDocumentsize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setDocumentsize = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string documentPath = 9;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getDocumentpath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setDocumentpath = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string indexStatus = 10;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getIndexstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setIndexstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional uint64 retrievalCount = 12;
 * @return {number}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getRetrievalcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setRetrievalcount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint64 tokenCount = 13;
 * @return {number}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getTokencount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setTokencount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint64 wordCount = 14;
 * @return {number}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getWordcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setWordcount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string DisplayStatus = 19;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getDisplaystatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setDisplaystatus = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string status = 21;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional uint64 createdBy = 22;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getCreatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setCreatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 22, value);
};


/**
 * optional User createdUser = 23;
 * @return {?proto.User}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getCreateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 23));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
*/
proto.knowledge_api.KnowledgeDocument.prototype.setCreateduser = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.clearCreateduser = function() {
  return this.setCreateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.KnowledgeDocument.prototype.hasCreateduser = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional uint64 updatedBy = 24;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getUpdatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.setUpdatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 24, value);
};


/**
 * optional User updatedUser = 25;
 * @return {?proto.User}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getUpdateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 25));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
*/
proto.knowledge_api.KnowledgeDocument.prototype.setUpdateduser = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.clearUpdateduser = function() {
  return this.setUpdateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.KnowledgeDocument.prototype.hasUpdateduser = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
*/
proto.knowledge_api.KnowledgeDocument.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.KnowledgeDocument.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.knowledge_api.KnowledgeDocument.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
*/
proto.knowledge_api.KnowledgeDocument.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.KnowledgeDocument} returns this
 */
proto.knowledge_api.KnowledgeDocument.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.KnowledgeDocument.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetAllKnowledgeDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentRequest}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetAllKnowledgeDocumentRequest;
  return proto.knowledge_api.GetAllKnowledgeDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentRequest}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 2:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 3:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetAllKnowledgeDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 knowledgeId = 1;
 * @return {string}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional Paginate paginate = 2;
 * @return {?proto.Paginate}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 2));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Criteria criterias = 3;
 * @return {!Array<!proto.Criteria>}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 3));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetAllKnowledgeDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.knowledge_api.KnowledgeDocument.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetAllKnowledgeDocumentResponse;
  return proto.knowledge_api.GetAllKnowledgeDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.knowledge_api.KnowledgeDocument;
      reader.readMessage(value,proto.knowledge_api.KnowledgeDocument.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetAllKnowledgeDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.knowledge_api.KnowledgeDocument.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated KnowledgeDocument data = 3;
 * @return {!Array<!proto.knowledge_api.KnowledgeDocument>}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.knowledge_api.KnowledgeDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.knowledge_api.KnowledgeDocument, 3));
};


/**
 * @param {!Array<!proto.knowledge_api.KnowledgeDocument>} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.knowledge_api.KnowledgeDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocument}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.knowledge_api.KnowledgeDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.CreateKnowledgeDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    documentsource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    datasource: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contentsList: jspb.Message.toObjectList(msg.getContentsList(),
    common_pb.Content.toObject, includeInstance),
    preprocess: jspb.Message.getFieldWithDefault(msg, 6, 0),
    separator: jspb.Message.getFieldWithDefault(msg, 7, ""),
    maxchunksize: jspb.Message.getFieldWithDefault(msg, 8, 0),
    chunkoverlap: jspb.Message.getFieldWithDefault(msg, 9, 0),
    name: jspb.Message.getFieldWithDefault(msg, 10, ""),
    description: jspb.Message.getFieldWithDefault(msg, 11, ""),
    documentstructure: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.CreateKnowledgeDocumentRequest;
  return proto.knowledge_api.CreateKnowledgeDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 2:
      var value = /** @type {!proto.knowledge_api.CreateKnowledgeDocumentRequest.DOCUMENT_SOURCE} */ (reader.readEnum());
      msg.setDocumentsource(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDatasource(value);
      break;
    case 5:
      var value = new common_pb.Content;
      reader.readMessage(value,common_pb.Content.deserializeBinaryFromReader);
      msg.addContents(value);
      break;
    case 6:
      var value = /** @type {!proto.knowledge_api.CreateKnowledgeDocumentRequest.PRE_PROCESS} */ (reader.readEnum());
      msg.setPreprocess(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeparator(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxchunksize(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChunkoverlap(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentstructure(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.CreateKnowledgeDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getDocumentsource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDatasource();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      common_pb.Content.serializeBinaryToWriter
    );
  }
  f = message.getPreprocess();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSeparator();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMaxchunksize();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getChunkoverlap();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDocumentstructure();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.PRE_PROCESS = {
  AUTOMATIC: 0,
  CUSTOM: 1
};

/**
 * @enum {number}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.DOCUMENT_SOURCE = {
  DOCUMENT_SOURCE_MANUAL: 0,
  DOCUMENT_SOURCE_TOOL: 1
};

/**
 * optional uint64 knowledgeId = 1;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional DOCUMENT_SOURCE documentSource = 2;
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest.DOCUMENT_SOURCE}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getDocumentsource = function() {
  return /** @type {!proto.knowledge_api.CreateKnowledgeDocumentRequest.DOCUMENT_SOURCE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentRequest.DOCUMENT_SOURCE} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setDocumentsource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string dataSource = 3;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getDatasource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setDatasource = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated Content contents = 5;
 * @return {!Array<!proto.Content>}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getContentsList = function() {
  return /** @type{!Array<!proto.Content>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Content, 5));
};


/**
 * @param {!Array<!proto.Content>} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
*/
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setContentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.Content=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Content}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.addContents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.Content, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.clearContentsList = function() {
  return this.setContentsList([]);
};


/**
 * optional PRE_PROCESS preProcess = 6;
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest.PRE_PROCESS}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getPreprocess = function() {
  return /** @type {!proto.knowledge_api.CreateKnowledgeDocumentRequest.PRE_PROCESS} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentRequest.PRE_PROCESS} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setPreprocess = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string separator = 7;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getSeparator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setSeparator = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 maxChunkSize = 8;
 * @return {number}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getMaxchunksize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setMaxchunksize = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 chunkOverlap = 9;
 * @return {number}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getChunkoverlap = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setChunkoverlap = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string name = 10;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string description = 11;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string documentStructure = 12;
 * @return {string}
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.getDocumentstructure = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentRequest} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentRequest.prototype.setDocumentstructure = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.CreateKnowledgeDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.knowledge_api.KnowledgeDocument.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.CreateKnowledgeDocumentResponse;
  return proto.knowledge_api.CreateKnowledgeDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.knowledge_api.KnowledgeDocument;
      reader.readMessage(value,proto.knowledge_api.KnowledgeDocument.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.CreateKnowledgeDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.CreateKnowledgeDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.knowledge_api.KnowledgeDocument.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated KnowledgeDocument data = 3;
 * @return {!Array<!proto.knowledge_api.KnowledgeDocument>}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.knowledge_api.KnowledgeDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.knowledge_api.KnowledgeDocument, 3));
};


/**
 * @param {!Array<!proto.knowledge_api.KnowledgeDocument>} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
*/
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.knowledge_api.KnowledgeDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocument}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.knowledge_api.KnowledgeDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
*/
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
*/
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.CreateKnowledgeDocumentResponse} returns this
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.CreateKnowledgeDocumentResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.KnowledgeDocumentSegment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocumentSegment.toObject = function(includeInstance, msg) {
  var f, obj = {
    index: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentHash: jspb.Message.getFieldWithDefault(msg, 19, ""),
    documentId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    text: jspb.Message.getFieldWithDefault(msg, 21, ""),
    metadata: (f = msg.getMetadata()) && proto.knowledge_api.KnowledgeDocumentSegment.Metadata.toObject(includeInstance, f),
    entities: (f = msg.getEntities()) && proto.knowledge_api.KnowledgeDocumentSegment.Entities.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment}
 */
proto.knowledge_api.KnowledgeDocumentSegment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.KnowledgeDocumentSegment;
  return proto.knowledge_api.KnowledgeDocumentSegment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment}
 */
proto.knowledge_api.KnowledgeDocumentSegment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentHash(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 22:
      var value = new proto.knowledge_api.KnowledgeDocumentSegment.Metadata;
      reader.readMessage(value,proto.knowledge_api.KnowledgeDocumentSegment.Metadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 23:
      var value = new proto.knowledge_api.KnowledgeDocumentSegment.Entities;
      reader.readMessage(value,proto.knowledge_api.KnowledgeDocumentSegment.Entities.deserializeBinaryFromReader);
      msg.setEntities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.KnowledgeDocumentSegment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocumentSegment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentHash();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.knowledge_api.KnowledgeDocumentSegment.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getEntities();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.knowledge_api.KnowledgeDocumentSegment.Entities.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.KnowledgeDocumentSegment.Metadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentHash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    knowledgeDocumentId: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    knowledgeId: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    projectId: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    organizationId: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    documentName: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.KnowledgeDocumentSegment.Metadata;
  return proto.knowledge_api.KnowledgeDocumentSegment.Metadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeDocumentId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrganizationId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.KnowledgeDocumentSegment.Metadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKnowledgeDocumentId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getKnowledgeId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getProjectId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getOrganizationId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getDocumentName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string document_hash = 1;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.getDocumentHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.setDocumentHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string document_id = 2;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 knowledge_document_id = 3;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.getKnowledgeDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.setKnowledgeDocumentId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional uint64 knowledge_id = 4;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.getKnowledgeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.setKnowledgeId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional uint64 project_id = 5;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 organization_id = 6;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string document_name = 7;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.getDocumentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Metadata} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Metadata.prototype.setDocumentName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.repeatedFields_ = [1,2,3,4,5,6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.KnowledgeDocumentSegment.Entities.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    datesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    productsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    eventsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    peopleList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    timesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    quantitiesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    locationsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    industriesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.KnowledgeDocumentSegment.Entities;
  return proto.knowledge_api.KnowledgeDocumentSegment.Entities.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrganizations(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDates(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addProducts(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvents(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPeople(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addQuantities(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addLocations(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addIndustries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.KnowledgeDocumentSegment.Entities.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getDatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getEventsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getPeopleList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getTimesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getQuantitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getIndustriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * repeated string organizations = 1;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getOrganizationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addOrganizations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};


/**
 * repeated string dates = 2;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getDatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setDatesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addDates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearDatesList = function() {
  return this.setDatesList([]);
};


/**
 * repeated string products = 3;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getProductsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setProductsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addProducts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * repeated string events = 4;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getEventsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setEventsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addEvents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearEventsList = function() {
  return this.setEventsList([]);
};


/**
 * repeated string people = 5;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getPeopleList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setPeopleList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addPeople = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearPeopleList = function() {
  return this.setPeopleList([]);
};


/**
 * repeated string times = 6;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getTimesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setTimesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addTimes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearTimesList = function() {
  return this.setTimesList([]);
};


/**
 * repeated string quantities = 7;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getQuantitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setQuantitiesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addQuantities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearQuantitiesList = function() {
  return this.setQuantitiesList([]);
};


/**
 * repeated string locations = 8;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getLocationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setLocationsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addLocations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};


/**
 * repeated string industries = 9;
 * @return {!Array<string>}
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.getIndustriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.setIndustriesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.addIndustries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment.Entities} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.Entities.prototype.clearIndustriesList = function() {
  return this.setIndustriesList([]);
};


/**
 * optional string index = 1;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.setIndex = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string document_hash = 19;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.getDocumentHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.setDocumentHash = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string document_id = 20;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string text = 21;
 * @return {string}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional Metadata metadata = 22;
 * @return {?proto.knowledge_api.KnowledgeDocumentSegment.Metadata}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.getMetadata = function() {
  return /** @type{?proto.knowledge_api.KnowledgeDocumentSegment.Metadata} */ (
    jspb.Message.getWrapperField(this, proto.knowledge_api.KnowledgeDocumentSegment.Metadata, 22));
};


/**
 * @param {?proto.knowledge_api.KnowledgeDocumentSegment.Metadata|undefined} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
*/
proto.knowledge_api.KnowledgeDocumentSegment.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional Entities entities = 23;
 * @return {?proto.knowledge_api.KnowledgeDocumentSegment.Entities}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.getEntities = function() {
  return /** @type{?proto.knowledge_api.KnowledgeDocumentSegment.Entities} */ (
    jspb.Message.getWrapperField(this, proto.knowledge_api.KnowledgeDocumentSegment.Entities, 23));
};


/**
 * @param {?proto.knowledge_api.KnowledgeDocumentSegment.Entities|undefined} value
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
*/
proto.knowledge_api.KnowledgeDocumentSegment.prototype.setEntities = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment} returns this
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.clearEntities = function() {
  return this.setEntities(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.KnowledgeDocumentSegment.prototype.hasEntities = function() {
  return jspb.Message.getField(this, 23) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest;
  return proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 3:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 4:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 knowledgeId = 1;
 * @return {string}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional Paginate paginate = 3;
 * @return {?proto.Paginate}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 3));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Criteria criterias = 4;
 * @return {!Array<!proto.Criteria>}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 4));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.knowledge_api.KnowledgeDocumentSegment.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse;
  return proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.knowledge_api.KnowledgeDocumentSegment;
      reader.readMessage(value,proto.knowledge_api.KnowledgeDocumentSegment.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.knowledge_api.KnowledgeDocumentSegment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated KnowledgeDocumentSegment data = 3;
 * @return {!Array<!proto.knowledge_api.KnowledgeDocumentSegment>}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.knowledge_api.KnowledgeDocumentSegment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.knowledge_api.KnowledgeDocumentSegment, 3));
};


/**
 * @param {!Array<!proto.knowledge_api.KnowledgeDocumentSegment>} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.knowledge_api.KnowledgeDocumentSegment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.KnowledgeDocumentSegment}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.knowledge_api.KnowledgeDocumentSegment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
*/
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse} returns this
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.knowledge_api.GetAllKnowledgeDocumentSegmentResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.UpdateKnowledgeDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.UpdateKnowledgeDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.UpdateKnowledgeDetailRequest}
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.UpdateKnowledgeDetailRequest;
  return proto.knowledge_api.UpdateKnowledgeDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.UpdateKnowledgeDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.UpdateKnowledgeDetailRequest}
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.UpdateKnowledgeDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.UpdateKnowledgeDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint64 knowledgeId = 1;
 * @return {string}
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDetailRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDetailRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDetailRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDetailRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.repeatedFields_ = [1,2,3,4,5,6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    datesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    productsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    eventsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    peopleList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    timesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    quantitiesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    locationsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    industriesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    documentname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    documentid: jspb.Message.getFieldWithDefault(msg, 11, ""),
    index: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest;
  return proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrganizations(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDates(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addProducts(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvents(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPeople(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addQuantities(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addLocations(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addIndustries(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentname(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentid(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getDatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getEventsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getPeopleList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getTimesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getQuantitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getIndustriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getDocumentname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDocumentid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * repeated string organizations = 1;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getOrganizationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addOrganizations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};


/**
 * repeated string dates = 2;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getDatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setDatesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addDates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearDatesList = function() {
  return this.setDatesList([]);
};


/**
 * repeated string products = 3;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getProductsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setProductsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addProducts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * repeated string events = 4;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getEventsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setEventsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addEvents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearEventsList = function() {
  return this.setEventsList([]);
};


/**
 * repeated string people = 5;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getPeopleList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setPeopleList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addPeople = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearPeopleList = function() {
  return this.setPeopleList([]);
};


/**
 * repeated string times = 6;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getTimesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setTimesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addTimes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearTimesList = function() {
  return this.setTimesList([]);
};


/**
 * repeated string quantities = 7;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getQuantitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setQuantitiesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addQuantities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearQuantitiesList = function() {
  return this.setQuantitiesList([]);
};


/**
 * repeated string locations = 8;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getLocationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setLocationsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addLocations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};


/**
 * repeated string industries = 9;
 * @return {!Array<string>}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getIndustriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setIndustriesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.addIndustries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.clearIndustriesList = function() {
  return this.setIndustriesList([]);
};


/**
 * optional string documentName = 10;
 * @return {string}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getDocumentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setDocumentname = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string documentId = 11;
 * @return {string}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getDocumentid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setDocumentid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string index = 12;
 * @return {string}
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.UpdateKnowledgeDocumentSegmentRequest.prototype.setIndex = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    index: jspb.Message.getFieldWithDefault(msg, 2, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest}
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest;
  return proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest}
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string documentId = 1;
 * @return {string}
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.getDocumentid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.setDocumentid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string index = 2;
 * @return {string}
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.setIndex = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest} returns this
 */
proto.knowledge_api.DeleteKnowledgeDocumentSegmentRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.knowledge_api);
